import type { DiagramDocument } from './types';
import { normalizeDocument } from './normalize';
import { validateDocument } from './validation';

export const OWDEX_DRAW_SCHEMA_VERSION = 1 as const;
export const OWDEX_DRAW_APP_VERSION = '1.0.0-rc3';
export const OWDEX_DRAW_FORMAT_ID = 'OWDEX Draw';
export const OWDEX_DRAW_NATIVE_EXTENSION = '.odxd';

export interface OpenDocumentResult {
  document: DiagramDocument;
  sourceVersion: string;
  migrated: boolean;
  warnings: string[];
}

/**
 * Stable native-format entry point for the 1.0 line.
 * Schema v1 remains backwards compatible with R1-R9; normalization only fills
 * optional fields introduced over time and never mutates the supplied object.
 */
export function openNativeDocument(value: unknown): OpenDocumentResult {
  const validation = validateDocument(value);
  if (!validation.valid) throw new Error(`Arquivo OWDEX Draw inválido: ${validation.errors.slice(0, 6).join(' ')}`);
  const input = value as DiagramDocument;
  const sourceVersion = input.metadata.version || 'desconhecida';
  const document = normalizeDocument(structuredClone(input));
  const migrated = sourceVersion !== OWDEX_DRAW_APP_VERSION;
  const warnings: string[] = [];
  if (migrated) warnings.push(`Projeto aberto a partir da versão ${sourceVersion} e normalizado para ${OWDEX_DRAW_APP_VERSION}.`);
  return { document, sourceVersion, migrated, warnings };
}

export function stampDocumentVersion(document: DiagramDocument): DiagramDocument {
  return {
    ...document,
    schemaVersion: OWDEX_DRAW_SCHEMA_VERSION,
    metadata: { app: OWDEX_DRAW_FORMAT_ID, version: OWDEX_DRAW_APP_VERSION },
  };
}
